import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { keys } from "./constants";

export const useInvalidateSubscriptions = () => {
  const queryClient = useQueryClient();
  return useCallback(
    () => queryClient.invalidateQueries({ queryKey: keys.subscriptions() }),
    [queryClient],
  );
};
